import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'history'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Előzmények törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('hu-HU')
                } catch (e) {
                }
                return dateText
            },

            ['moreFromMy' + Ns + 'Title']: 'További előzményeim',
            ['moreFromUser' + Ns + 'Title']: 'További előzmények',

            [ns + 'FilterActionLabel']: 'Akció',
            [ns + 'FilterActionPlaceholder']: 'Akció neve',
            [ns + 'FilterTargetLabel']: 'Cél',
            [ns + 'FilterTargetPlaceholder']: 'Gomb neve',
            [ns + 'FilterReferrerLabel']: 'Referrer',
            [ns + 'FilterReferrerPlaceholder']: 'Oldal URL',
            [ns + 'FilterCreatedDateFrom']: 'Létrehozás dátuma (tól)',
            [ns + 'FilterCreatedDateTo']: 'Létrehozás dátuma (ig)'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Előzmények',
            ['my' + Ns + 'Menu']: 'Előzményeim',
            ['new' + N + 'Menu']: 'Új előzmény',
            [ns + 'Menu']: 'Előzmények',

            ['deleted' + Ns + 'Menu']: 'Törölt előzmények',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt előzmények',
            ['protection' + Ns + 'Menu']: 'Védett előzmények',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az előzmény mentésre került',
            ['save' + N + 'SuccessMessage']: 'Az előzmény mentésre került',
            ['delete' + N + 'Success']: 'Az előzmény törölve lett',
            ['delete' + Ns + 'Success']: 'Az előzmények törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli az előzményt?',
            ['delete' + Ns + 'Question']: 'Biztosan törli az előzményeket?',
            ['ban' + N + 'Success']: 'Az előzmény véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy az előzményt véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'Az előzmény jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod az előzményt',
            ['protection' + N + 'Success']: 'Az előzmény védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd az előzményt?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek előzmények'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Előzmény',
            [ns + 'Title']: 'Előzmények',
            ['new' + N + 'Title']: 'Új előzmény',
            ['edit' + N + 'Title']: 'Előzmény szerkesztése',
            ['user' + Ns + 'Title']: 'Előzmények',
            ['userDeleted' + Ns + 'Title']: 'Törölt előzmények',
            ['my' + Ns + 'Title']: 'Előzményeim',
            ['myDeleted' + Ns + 'Title']: 'Törölt előzményeim',

            ['dialogDelete' + N + 'Title']: 'Előzmény törlése',
            ['dialogBan' + N + 'Title']: 'Előzmény törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Előzmény jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Előzmény védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Előzmény védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Előzmények törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt előzmények',
            ['deleted' + Ns + 'Title']: 'Törölt előzmények',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett előzmények',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Előzmények kiválasztása',
            ['select' + N]: 'Előzmény kiválasztása'
        }
    }
}
